import styled from 'styled-components'

import tokens from '../tokens'

const { fonts } = tokens

export const Style = styled.div`
  .container-detail-service-product {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
  }

  .content-detail-service-product {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal {
    width: 45vw;
    height: 80vh;
    background: white;
    color: white;
    z-index: 1000;
    border-radius: 16px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: space-between;
  }

  .divider {
    height: 8px;
    background-color: #f4f4f4;
  }

  .container-top {
    height: 50%;
  }

  .container-close {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 20px;
    cursor: pointer;
  }

  .text-title {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.31px;
    display: ${props => props.display || 'unset'};
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }

  .text-subtitle {
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 13px;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }

  .sub-content {
    padding: 20px;
    height: 35%;
    overflow: scroll;
  }

  .container-subtitle {
    margin-top: 14px;
  }

  .container-alert-card {
    margin-top: 14px;
    padding: 14px;
    display: flex;
    flex-direction: row;
    background-color: #f3f3f3;
    border-radius: 8px;
  }

  .icon-images {
    width: 18px !important;
    height: 18px;
    margin-right: 10px;
  }

  .title-duration {
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }

  .container-duration {
    margin: 14px 0;
  }

  .container-vendor-equipment {
    display: flex;
    flex-direction: row;
  }

  .sub-content-vendor-equipment {
    margin-left: 20px;
  }

  .content-duration {
    margin-top: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content-duration-size {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .circle-shape {
    margin-right: 20px;
    width: 5px !important;
    height: 5px;
    border-radius: 50%;
    display: inline-block;
    background-color: #494949;
  }

  .container-button {
    height: 15%;
    margin: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .content-button {
    padding: 10px;
    width: 15vw;
    background-color: #ff7417;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
  }

  .text-button {
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #ffffff;
    text-align: ${props => props.align || 'unset'};
  }

  .container-image-banner {
    margin: 20px 20px 0 20px;
    height: 75%;
    background-size: cover;
    border-radius: 10px;
  }

  @media screen and (min-width: 200px) and (max-width: 480px) {
    .content-detail-service-product {
      position: fixed;
      top: 55%;
    }

    .modal {
      height: 90vh;
      position: relative;
      width: 100vw;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      animation: animationMobileModal 0.5s;
      animation-direction: alternate;
    }

    .sub-content {
      height: 48vh;
    }

    .content-button {
      width: 100vh;
    }

    .container-top {
      height: 35%;
    }

    .sub-content {
      height: 45%;
    }

    .container-button {
      height: 20%;
    }

    .container-image-banner {
      height: 70%;
    }
  }

  @keyframes animationMobileModal {
    0% {
      bottom: 90vh;
      top: 90vh;
    }
    100% {
      bottom: 90vh;
      top: 0px;
    }
  }
`
